import { RouteObject } from 'react-router-dom';

import { DashboardActivity } from './DashboardActivity/DashboardActivity';
import { MacroEconomicsLayout } from './MacroEconomicsLayout';



export const root: RouteObject = {

  path: 'macroeconomics',
  element: (
    <MacroEconomicsLayout />
  ),
  children: [{
    path: '',
    element: <DashboardActivity />
  }]

};
